module.exports = __webpack_public_path__ + "static/media/03-2-galeria-04-omega-mobile@2x.f09d3528.jpg";